import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import { vuetifyColors } from '../../../utils/themes';
export default _objectSpread(_objectSpread({
  name: 'NiotaClassicCommonN1CardBody'
}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])), {}, {
  props: {
    items: {
      type: Array,
      required: false,
      default: null
    },
    property: {
      type: String,
      required: false,
      default: ''
    },
    packets: {
      type: Boolean,
      required: false
    },
    infoProperty1: {
      type: String,
      required: false,
      default: ''
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: false
    },
    maxHeight: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {};
  },
  computed: {},
  watch: {},
  created: function created() {// this.items = cloneDeep(this.items);
  },
  methods: {
    timeColorFn: function timeColorFn() {
      return vuetifyColors['success'];
    },
    timestampToTimeOnly: function timestampToTimeOnly(timestamp) {
      return new Date(timestamp).toLocaleTimeString('en-GB');
    },
    viewDevice: function viewDevice(item) {
      this.$router.push({
        path: "/niota-classic/devices/".concat(this.infoProperty1 === 'source_time' ? item.device_id : item.id, "/details")
      });
    }
  }
});